import styled from '@emotion/styled/macro'
import { Avatar, ButtonBase, Menu, MenuItem, Typography } from '@mui/material'
import theme from 'theme'

/* The sidebar footer is a list, so the switcher's row needs a list item of its own. */
export const SwitcherItem = styled('li')`
  list-style: none;
  width: 100%;
`

export const SwitcherRow = styled(ButtonBase)<{ isexpanded: string }>`
  width: ${({ isexpanded }) => (isexpanded === 'true' ? '100%' : '48px')};
  min-width: 48px;
  height: 48px;
  padding: ${theme.spacing.sm}px;
  margin-bottom: ${theme.spacing.small}px;
  border-radius: ${theme.attributes.borderRadius.tertiary};
  display: flex;
  align-items: center;
  justify-content: ${({ isexpanded }) => (isexpanded === 'true' ? 'flex-start' : 'center')};
  gap: ${theme.spacing.sm}px;
  overflow: hidden;

  &:hover {
    background: ${theme.colors.hoverPrimary};
  }
`

export const AccountLogo = styled(Avatar)`
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  background: ${theme.colors.avatarBg};
  color: ${theme.colors.avatarText};
  text-transform: uppercase;
  font-family: ${theme.typography.fontFamily.primary};
  font-size: ${theme.typography.fontSize.medium};
  font-weight: ${theme.typography.fontWeight.bold};
  letter-spacing: 0.1px;
`

export const AccountName = styled(Typography)`
  flex: 1;
  text-align: left;
  font-family: ${theme.typography.fontFamily.primary};
  font-size: ${theme.typography.fontSize.large};
  font-weight: ${theme.typography.fontWeight.extraThick};
  line-height: 20px;
  letter-spacing: 0.1px;
  color: ${theme.colors.textSecondary};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`

export const OverlayLabel = styled(Typography)`
  font-family: ${theme.typography.fontFamily.primary};
  font-size: ${theme.typography.fontSize.xLarge};
  font-weight: ${theme.typography.fontWeight.extraThick};
  letter-spacing: 0.1px;
  color: ${theme.colors.neutral};
`

export const AccountMenu = styled(Menu)`
  .MuiPaper-root {
    min-width: 240px;
    max-width: 320px;
    max-height: 360px;
    margin-left: ${theme.spacing.xSmall}px;
    padding: ${theme.spacing.xSmall}px 0;
    background: ${theme.colors.menuBg};
    border-radius: ${theme.attributes.borderRadius.tertiary};
    box-shadow: ${theme.attributes.boxShadow.secondary};
  }
`

export const AccountMenuItem = styled(MenuItem)`
  padding: ${theme.spacing.sm}px ${theme.spacing.small}px;
  font-family: ${theme.typography.fontFamily.primary};
  font-size: ${theme.typography.fontSize.large};
  font-weight: ${theme.typography.fontWeight.extraThick};
  line-height: 20px;
  letter-spacing: 0.1px;
  color: ${theme.colors.menuItemText};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;

  &.Mui-selected {
    background: ${theme.colors.surfaceItemBackgroundLow};
    color: ${theme.colors.textPrimary};

    &:hover {
      background: ${theme.colors.surfaceItemBackgroundLow};
    }
  }

  /* The current account is unclickable, not unavailable — it must not read as greyed out. */
  &.Mui-selected.Mui-disabled {
    opacity: 1;
  }

  &:hover {
    background: ${theme.colors.hoverPrimary};
  }
`
